import { render } from "./VuetableColGroup.vue?vue&type=template&id=f3550ad8"
import script from "./VuetableColGroup.vue?vue&type=script&lang=js"
export * from "./VuetableColGroup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__